import { useBrokerDesk } from "../../js/hooks/useBrokerDesk";
import { BROKER_DESK } from "../../js/api/brokerDesk";

export default function BrokerDeskSwitch() {
  const { active, mode, setMode } = useBrokerDesk();
  if (!active) return null;

  return (
    <div className="broker-desk-switch" role="tablist" aria-label="Broker desk scope">
      <button
        type="button"
        role="tab"
        aria-selected={mode === BROKER_DESK.mine}
        className={mode === BROKER_DESK.mine ? "is-active" : ""}
        onClick={() => setMode(BROKER_DESK.mine)}
      >
        My Business
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={mode === BROKER_DESK.office}
        className={mode === BROKER_DESK.office ? "is-active" : ""}
        onClick={() => setMode(BROKER_DESK.office)}
      >
        All Agents
      </button>
    </div>
  );
}
